<nb-card [style.width.px]="600">
    <nb-card-header>
        <h5 *ngIf="isEditMode">Labot kontaktinformāciju</h5>
        <h5 *ngIf="!isEditMode">Pievienot kontaktinformāciju</h5>
    </nb-card-header>
    <nb-card-body>
        <div *ngIf="toFlyAuthorityConfig">
            <form (ngSubmit)="submit()" #form="ngForm" aria-labelledby="title">
                <div class="form-control-group mt-3">
                    <amdb-text-type-input
                        [required]="true"
                        [requiredLanguageIds]="toFlyAuthorityConfig.requiredLanguageIdsForToFlyAuthorityName"
                        [(textTypeEntries)]="toFlyAuthority.name"
                        [longText]="false"
                        controlName="name"
                        controlLabel="Nosaukums"
                    ></amdb-text-type-input>
                </div>

                <div class="form-control-group mt-3">
                    <amdb-text-type-input
                        [requiredLanguageIds]="toFlyAuthorityConfig.requiredLanguageIdsForToFlyAuthorityService"
                        [(textTypeEntries)]="toFlyAuthority.service"
                        [longText]="false"
                        controlName="service"
                        controlLabel="Serviss"
                    ></amdb-text-type-input>
                </div>

                <div class="form-control-group mt-3">
                    <amdb-text-type-input
                        [requiredLanguageIds]="toFlyAuthorityConfig.requiredLanguageIdsForToFlyAuthorityContactName"
                        [(textTypeEntries)]="toFlyAuthority.contactName"
                        [longText]="false"
                        controlName="contactName"
                        controlLabel="Kontaktpersona"
                    ></amdb-text-type-input>
                </div>

                <div class="form-control-group mt-3">
                    <label class="label" for="siteUrl">Mājaslapa</label>
                    <input
                        nbInput
                        [(ngModel)]="toFlyAuthority.siteUrl"
                        #siteUrl="ngModel"
                        id="siteUrl"
                        name="siteUrl"
                        placeholder="Mājaslapa"
                        fullWidth
                        maxlength="200"
                        [status]="siteUrl.touched ? (siteUrl.invalid ? 'danger' : 'success') : 'primary'"
                        [attr.aria-invalid]="siteUrl.invalid && siteUrl.touched ? true : null"
                    />
                </div>

                <div class="form-control-group mt-3">
                    <label class="label" for="email">E-pasts</label>
                    <input
                        nbInput
                        [(ngModel)]="toFlyAuthority.email"
                        #email="ngModel"
                        id="email"
                        name="email"
                        pattern=".+@.+..+"
                        placeholder="E-pasts"
                        fullWidth
                        maxlength="200"
                        [status]="email.touched ? (email.invalid ? 'danger' : 'success') : 'primary'"
                        [required]="true"
                        [attr.aria-invalid]="email.invalid && email.touched ? true : null"
                    />
                    <ng-container *ngIf="email.invalid && email.touched">
                        <p class="error-message" *ngIf="email?.errors?.required">
                            Lauks ir obligāts!
                        </p>
                        <p class="error-message" *ngIf="email?.errors?.pattern">
                            E-pasta adresei jābūt reālai!
                        </p>
                    </ng-container>
                </div>

                <div class="form-control-group mt-3">
                    <label class="label" for="phone">Telefons</label>
                    <input
                        nbInput
                        [(ngModel)]="toFlyAuthority.phone"
                        #phone="ngModel"
                        id="phone"
                        name="phone"
                        placeholder="Telefons"
                        fullWidth
                        maxlength="200"
                        [required]="true"
                        pattern="^((((\+371{1}((2{1})|(6{1}))[0-9]{7})|(((2{1})|(6{1}))[0-9]{7})))(\,)?|(\,\s)?)+$"
                        [status]="phone.touched ? (phone.invalid ? 'danger' : 'success') : 'primary'"
                        [attr.aria-invalid]="phone.invalid && phone.touched ? true : null"
                    />
                    <ng-container *ngIf="phone.invalid && phone.touched">
                        <p class="error-message" *ngIf="phone?.errors?.required">
                            Lauks ir obligāts!
                        </p>
                        <p class="error-message" *ngIf="phone?.errors?.pattern">
                            Telefona numuram jābūt reālam
                        </p>
                    </ng-container>
                </div>

                <div class="form-control-group mt-3" *ngIf="authority.isAutoSubmitter">
                    <label class="label" for="authorityDataGroup">Datu grupa</label>
                    <nb-select
                        [(ngModel)]="toFlyAuthority.dataGroupId"
                        #authorityDataGroup="ngModel"
                        status="primary"
                        fullWidth
                        name="authorityDataGroup"
                        [required]="true"
                        [status]="authorityDataGroup.touched ? (authorityDataGroup.invalid ? 'danger' : 'success') : 'primary'"
                        [attr.aria-invalid]="authorityDataGroup.invalid && authorityDataGroup.touched ? true : null"
                        >>
                        <nb-option *ngFor="let dataGroup of authorityDataGroups" [value]="dataGroup.id">{{ dataGroup.name }}</nb-option>
                    </nb-select>
                    <ng-container *ngIf="authorityDataGroup.invalid && authorityDataGroup.touched">
                        <p class="error-message" *ngIf="authorityDataGroup.errors?.required">
                            Lauks ir obligāts!
                        </p>
                    </ng-container>
                </div>

                <button nbButton fullWidth status="success" class="mt-3" [disabled]="!form.valid">
                    Saglabāt
                </button>
            </form>
        </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Aizvērt</button>
    </nb-card-footer>
</nb-card>
